import { award_event_id, DOWNLOAD_PERFORMA_INVOICE, downloadReport, fetchAuthReport, GET_PROFORMA_LIST_ACTION_TYPE, getProformaListUrl, headers, INSERT_UPDATE_PROFORMA_ACTION_TYPE, insertUpdateProformaUrl, user_id } from "../../../utils/constants";
import { axiosGet, axiosPost } from "../../../react_axios/Axios";

export const get_proformaList_action =
  (ApplicantName, proformaDate, proformaInvoiceNo, application_no) => async (dispatch) => {
    try {
      const mapdata = {
        user_id: sessionStorage.getItem("user_id"),
        award_event_id: sessionStorage.getItem("award_event_id"),
        applicant_name: ApplicantName,
        proforma_invoice_date: proformaDate,
        proforma_invoice_no: proformaInvoiceNo,
        application_no: application_no
      };
      const res = await axiosGet(getProformaListUrl, mapdata, headers);
      dispatch({
        type: GET_PROFORMA_LIST_ACTION_TYPE,
        payload: res,
      });
      return res;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const insert_update_proforma_action =
  (application_form_id, application_status_id) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id: sessionStorage.getItem("user_id"),
          application_form_id: application_form_id != null ? application_form_id : null,
          application_status_id: application_status_id,
        };
    const res = await axiosPost(insertUpdateProformaUrl, mapdata, headers);
        dispatch({
          type: INSERT_UPDATE_PROFORMA_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };


export const download_proforma_action =
  (application_form_id, proforma_invoice_id) => async (dispatch) => {
    try {
      var list = [];
      const mapdata = {
        "ParameterName": "@application_form_id",
        "ParameterValue": application_form_id,
        "ParameterDataType": "int"
      }
      const mapdata2 = {
        "ParameterName": "@proforma_invoice_id",
        "ParameterValue": proforma_invoice_id,
        "ParameterDataType": "int"
      }
      list.push(mapdata);
      list.push(mapdata2);
      const mapData = {
        "user_id": user_id,
        "report_name": "award_proforma.rpt",
        "report_file_name": `award_proforma_${application_form_id}`,
        "config_id": 0,
        "parameter_details": list,

      }
      const res = await axiosPost(fetchAuthReport, mapData, headers);
      dispatch({
        type: DOWNLOAD_PERFORMA_INVOICE,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };